import { lazy, Suspense } from "react";
import Loader from '../customs/spinner/spinner';

const Main = lazy(() => import('../components/replacePassword/main'));

const ReplacePassword = () => {
    return (
            <Suspense fallback={<Loader color="#E57D1E"/>}>
                <Main/>
            </Suspense>
    )
}

export default ReplacePassword;